import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-6 mt-9" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "el-upload-list__item-thumbnail w-50 mt-10 ms-10",
  src: "/svg/icons/delete.svg"
}
const _hoisted_6 = { class: "el-upload-list__item-actions" }
const _hoisted_7 = { class: "file-name" }
const _hoisted_8 = { class: "file-size" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-delete ms-0 text-white" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("attachments")), 1),
    _createVNode(_component_el_upload, {
      action: "#",
      "list-type": "picture-card",
      "auto-upload": false,
      limit: 10,
      name: "dialogImageUrl",
      value: _ctx.value,
      data: _ctx.value,
      "on-change": _ctx.handleChange,
      multiple: "",
      "file-list": _ctx.value,
      ref: "uploadInput"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      file: _withCtx(({ file }) => [
        _createElementVNode("div", null, [
          (
              file.raw.type === 'image/png' ||
              file.raw.type === 'image/svg+xml' ||
              file.raw.type === 'image/jpg' ||
              file.raw.type === 'image/jpeg'
            )
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "el-upload-list__item-thumbnail",
                src: file.url
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(file.name), 1),
            _createElementVNode("p", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.formatBytes(file.size)), 1)
            ]),
            _createElementVNode("span", {
              class: "el-upload-list__item-delete ms-0",
              onClick: ($event: any) => (_ctx.removeFile(file))
            }, _hoisted_11, 8, _hoisted_9)
          ])
        ])
      ]),
      _: 1
    }, 8, ["value", "data", "on-change", "file-list"])
  ]))
}